export default "__VITE_ASSET__Oioxg1Rn__"